// Minimum pixels padding needed at the edge of the
// screen where the episode menu displays
const minimumMenuPadding = 16;
// Pixel adjustment for episode menu to line it up
// properly with its respective track
const menuAdjustment = 2;

// Display to the left of the episode, top aligned
const leftAndTopAligned = ({
  episodeRect,
  menuWidth
}) => ({
  top: episodeRect.top - menuAdjustment,
  right: 'unset',
  bottom: 'unset',
  left: episodeRect.left - menuWidth - minimumMenuPadding
});

// Display to the left of the episode, top aligned
const leftAndBottomAligned = ({
  episodeRect,
  menuWidth,
  windowHeight
}) => ({
  top: 'unset',
  right: 'unset',
  bottom: (windowHeight - episodeRect.bottom) + menuAdjustment,
  left: episodeRect.left - menuWidth - minimumMenuPadding
});

// Display at in the center of the screen as it fits nowhere else
const centerAligned = ({
  episodeRect,
  menuWidth
}) => ({
  top: 0,
  right: 'unset',
  bottom: 0,
  left: episodeRect.left - menuWidth - minimumMenuPadding,
  margin: 'auto'
});

const calculateEpisodeMenuStyle = ({
  windowWidth,
  windowHeight,
  episodeMenuBoundingClientRect: menuRect,
  episodeBoundingClientRect: episodeRect
}) => {
  const menuWidth = menuRect.width;
  const menuHeight = menuRect.height;

  const menuOverlapsScreenBottom = (episodeRect.top + menuHeight) > windowHeight;
  const menuOverlapsScreenTop = ((episodeRect.top - menuHeight) < 0);

  // Params to pass to the functions which
  // return styles for each menu plaement
  const params = {
    episodeRect,
    menuWidth,
    windowWidth,
    windowHeight
  };

  // By default, place the menu to the right of the track
  let style = leftAndTopAligned(params);

  if (menuOverlapsScreenBottom) {
    style = leftAndBottomAligned(params);
  }

  if (menuOverlapsScreenBottom && menuOverlapsScreenTop) {
    style = centerAligned(params);
  }

  return style;
};

export default calculateEpisodeMenuStyle;